module.exports = __webpack_public_path__ + "static/media/Template-USPS.fe4bc028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/modules/channel/pages/Template-USPS.svg
// module id = 3728
// module chunks = 4